export default __webpack_public_path__ + "static/media/4.309a93e8.jpg";